import { Navigate, generatePath } from 'react-router-dom';

import { FOOTBALL_SCOUTING_CENTER } from '@sorare/core/src/constants/__generated__/routes';

const ScoutingCenterRegularCompetitionPage = () => {
  return <Navigate to={generatePath(FOOTBALL_SCOUTING_CENTER)} replace />;
};

export default ScoutingCenterRegularCompetitionPage;
